import i18next from 'i18next'
import React from 'react'
import { InView } from 'react-intersection-observer'
import { ButtonPrimary } from '../../../../utils/buttons'
import { blockInviewHandler } from '../../../../utils/inview'
import { SVGIcon } from '../../../../utils/svgicon'
import { ComponentTeasersInnerContentLayout } from '../../components/componentTeasers/componentTeasersLayout'
import { PictureLayout } from '../../image/imageLayout'
import { RootLayout } from '../../rootLayout'
import { GuestChefHighlight } from './guestChefHighLight.state'
import { Link } from 'widgets-for-react'

export const GuestChefHighlightLayout = (p: {
  guestChef: GuestChefHighlight | 'loading' | 'error'
  isSaved: (id: number) => boolean | 'unknown'
  onSaveOrDelete: (id: number) => void
}) => {
  const guestChefSearchLink =
    p.guestChef != 'loading' && p.guestChef != 'error'
      ? `${i18next.language}/search?term=${p.guestChef.lastName}`
      : ''
  return (
    <InView
      as="section"
      threshold={0}
      triggerOnce={true}
      onChange={(isInView, entry) => blockInviewHandler(isInView, entry.target)}
      className="block block--guest-chef-highlight bg--dark bg spacing--s"
    >
      <div className="block__inner container--m gutter--m">
        <header className="block__header reverse-order">
          {p.guestChef != 'loading' && p.guestChef != 'error' && (
            <h2 className="block__title title--xl">
              {p.guestChef.firstName} {p.guestChef.lastName}
            </h2>
          )}
          <div className="block__label">
            <span className="title--xxs text--brand">
              {i18next.t('home:guestChefTitle')}
            </span>
            <SVGIcon iconId="knife" size={64} />
          </div>
        </header>

        {p.guestChef === 'loading' ? (
          <RootLayout.Loader hasWrapper={true} showText={true} />
        ) : p.guestChef == 'error' ? (
          <RootLayout.LoadingFailed
            text={i18next.t('common:loadingFailed', {
              entity: i18next
                .t('component:componentsTitle_plural')
                .toLowerCase(),
            })}
          />
        ) : (
          <div className="block__content">
            <Link to={guestChefSearchLink} className="block__visual">
              <PictureLayout.Img
                image={p.guestChef.image}
                width="620"
                height="380"
                extraClasses="block__image"
                lazyload
              />
            </Link>

            <p className="block__intro">{p.guestChef.introduction}</p>

            <div className="block__teasers">
              <ComponentTeasersInnerContentLayout
                kind="guest-chef-highlight"
                componentTeasers={p.guestChef.components}
                teaserKind="link-save"
                isSaved={p.isSaved}
                onSaveOrDelete={p.onSaveOrDelete}
                isComparableComponents={false}
              />
            </div>

            <div className="block__clickable">
              <ButtonPrimary
                kind="link"
                size="s"
                extraClasses="block__button"
                to={guestChefSearchLink}
                label={i18next.t('home:guestChefCTA', {
                  chefName: p.guestChef.firstName,
                })}
              />
            </div>
          </div>
        )}
      </div>
    </InView>
  )
}
